import type { SSEManager } from './sseUtils';
import { createRefCountedRegistry } from './refCountedRegistry';

const sseRegistry = createRefCountedRegistry<SSEManager>();

export function getOrCreateSSE(aiThreadId: string, factory: () => SSEManager): SSEManager {
  return sseRegistry.getOrCreate(aiThreadId, factory);
}

export function acquireSSE(aiThreadId: string, factory: () => SSEManager): SSEManager {
  return sseRegistry.acquire(aiThreadId, factory);
}

export function getSSE(aiThreadId: string): SSEManager | null {
  return sseRegistry.get(aiThreadId);
}

export function destroySSE(aiThreadId: string): void {
  sseRegistry.destroy(aiThreadId);
}

export function releaseSSE(aiThreadId: string): void {
  sseRegistry.release(aiThreadId);
}

export function clearAllSSE(): void {
  sseRegistry.clearAll();
}
